import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../../__root";

export const endUserCallViewerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/call/$callId",
  validateSearch: (search): { viewToken: string } => ({
    viewToken: typeof search.viewToken === "string" ? search.viewToken : "",
  }),
}).lazy(() => import("./EndUserCallViewer.lazy").then((d) => d.Route));
